module.exports = __webpack_public_path__ + "img/wx_sph.aae046e0.jpg";